import dayjs from 'dayjs';

export const formatDate = (dateToFormat, time = false, supabaseFormat = false) => {
  dateToFormat = dateToFormat !== '0000-00-00' ? dateToFormat : '-';
  let formattedDate = dayjs(dateToFormat);
  const format = time ? 'DD/MM/YYYY HH:mm' : supabaseFormat ? 'YYYY-MM-DD' : 'DD/MM/YYYY';
  return formattedDate.isValid() ? formattedDate.format(format) : '-';
};
